'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _currency_utility = require('../../../packages/common-utilities/src/currency_utility.js');

var _currency_utility2 = _interopRequireDefault(_currency_utility);

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _formatted_number = require('./global_components/formatted_number');

var _formatted_number2 = _interopRequireDefault(_formatted_number);

var _ramda = require('ramda');

var _collection_utility = require('common-utilities/src/collection_utility');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _number_utility = require('../../../packages/common-utilities/src/number_utility');

var _accessibility_utility = require('../../../packages/common-utilities/src/accessibility_utility');

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var NAV = function (_React$Component) {
  _inherits(NAV, _React$Component);

  function NAV(props) {
    _classCallCheck(this, NAV);

    var _this = _possibleConstructorReturn(this, (NAV.__proto__ || Object.getPrototypeOf(NAV)).call(this, props));

    _this.tooltipId = "pdpDataPointNAV";
    _this.asOfLabel = _string_utility2.default.renderFormattedLabel("As of ", "label-for-as-of", { role: _this.props.role });
    return _this;
  }

  _createClass(NAV, [{
    key: 'getChangePerPercentage',
    value: function getChangePerPercentage(changePerPercentage) {
      if (!(0, _functional_utility.isNilOrEmpty)(this.props.formattingRules) && (0, _ramda.includes)("QUICK_STAT_NAV_CHANGE_PERCENTAGE_ONE_DP", this.props.formattingRules)) {
        return (0, _number_utility.formatToPercentWith1FixedDecimals)(changePerPercentage);
      } else {
        return (0, _number_utility.formatToPercentWith2FixedDecimals)(changePerPercentage);
      }
    }
  }, {
    key: 'renderChangeAmount',
    value: function renderChangeAmount(changeAmount, changePerPercentage) {
      if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'QUICK_STAT_HIDE_NAV_CHANGE')) {
        return null;
      }

      var amount = this.props.shouldUseTranslatedMessageToFormatCurrency ? _currency_utility2.default.formatCurrencyInRegionTranslatedFormat(this.props.country, changeAmount, this.props.shareclassCurrencyCode, this.props.fundTypeCode, 0) : _currency_utility2.default.convertToCurrency(changeAmount, this.props.currencyCode);

      var formattedChangePerPercentage = "";
      if (!(0, _functional_utility.isNilOrEmpty)(this.props.visibleDataPoints) && (0, _ramda.includes)("QUICK_STAT_NAV_CHANGE_CUSTOMIZE", this.props.visibleDataPoints)) {
        formattedChangePerPercentage = (0, _ramda.isNil)(changePerPercentage) ? "-" : this.getChangePerPercentage(changePerPercentage);
        amount = formattedChangePerPercentage;
      }

      return _react2.default.createElement(
        'div',
        { className: 'display-inline-block margin-top-5 margin-right-10' },
        _react2.default.createElement(
          'span',
          { className: 'display-block disclaimer font-black-variant', 'data-testid': this.props.dataTest + '-change-header' },
          _string_utility2.default.renderFormattedLabel("Change", "pdp-quick-stat-nav-change-amount-label")
        ),
        _react2.default.createElement(
          'span',
          { className: 'display-block ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "tag", "sub-header-2") + ' font-black-variant', 'data-testid': this.props.dataTest + '-change-amount' },
          amount
        )
      );
    }
  }, {
    key: 'renderIcon',
    value: function renderIcon(tooltipId) {
      var _this2 = this;

      if (!this.props.disclosure || (0, _ramda.isNil)(this.props.disclosure) || (0, _ramda.isNil)(this.props.visibleDataPoints) || !(0, _ramda.includes)("QUICK_STAT_NAV_REIT_DISCLOSURE", this.props.visibleDataPoints)) {
        return null;
      }

      return _react2.default.createElement(
        'span',
        { id: 'disclosure-' + tooltipId, tabIndex: 0, className: 'icon-info print-hide',
          role: 'tooltip',
          onKeyDown: function onKeyDown(event) {
            return _accessibility_utility2.default.handleEnterClick(_this2, event, _this2.handleDisclosureIconClick.bind(_this2, event, tooltipId));
          },
          onClick: function onClick(event) {
            return _this2.handleDisclosureIconClick(event, tooltipId);
          }
        },
        ' '
      );
    }
  }, {
    key: 'handleDisclosureIconClick',
    value: function handleDisclosureIconClick(event, tooltipId) {
      var el = this.getIconEl(tooltipId);
      var elHeight = el.offsetHeight;
      var elWidth = el.parentNode.getBoundingClientRect().left;
      var elRect = el.getBoundingClientRect();
      var arrowHeight = 4;
      var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;

      var elOffset = {
        top: elRect.top + docTop + arrowHeight + elHeight,
        left: elWidth,
        arrowPosition: elRect.left - elWidth - 3
      };

      this.props.tooltip.openTooltip(elOffset, this.props.disclosure, null, true, event);
    }
  }, {
    key: 'getIconEl',
    value: function getIconEl(tooltipId) {
      return document.getElementById('disclosure-' + tooltipId);
    }
  }, {
    key: 'renderNavHeaderAndAsOfDate',
    value: function renderNavHeaderAndAsOfDate(asOfDate, navPrice, timeZone) {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'tag font-black-variant', 'data-testid': this.props.dataTest + '-header' },
          this.props.label,
          ' ',
          this.renderIcon(this.tooltipId),
          timeZone && _react2.default.createElement(
            'span',
            { className: (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "disclaimer", "category") + ' font-slate-grey', 'data-testid': this.props.dataTest + '-timeZone' },
            " (" + timeZone + " ",
            _string_utility2.default.renderFormattedLabel("time", "pdp-time-label"),
            ")"
          )
        ),
        _react2.default.createElement(
          'span',
          null,
          asOfDate && navPrice && _react2.default.createElement(
            'div',
            { className: (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "disclaimer", "category") + ' font-slate-grey', 'data-testid': this.props.dataTest + '-as-of-date' },
            this.asOfLabel,
            asOfDate
          )
        )
      );
    }
  }, {
    key: 'renderNav',
    value: function renderNav(isLocalTimeZone, changeAmount) {
      var asOfDate = _date_formatter2.default.getLocalFormattedDate(this.props.nav.date, this.props.country);
      var navPrice = this.props.nav.price;
      var amount = this.props.shouldUseTranslatedMessageToFormatCurrency === true ? _currency_utility2.default.formatCurrencyInRegionTranslatedFormat(this.props.country, navPrice, this.props.shareclassCurrencyCode, this.props.fundTypeCode, this.props.navDecimalPoints, null, this.props.visibleData) : _currency_utility2.default.convertToCurrencyForNav(navPrice, this.props.currencyCode, this.props.fundTypeCode, this.props.country, this.props.navDecimalPoints);
      var changePerPercentage = this.props.nav.changePercentage;

      return _react2.default.createElement(
        'div',
        null,
        this.renderNavHeaderAndAsOfDate(asOfDate, navPrice),
        _react2.default.createElement(
          'div',
          { className: 'display-inline-block margin-top-5 margin-right-10' },
          _react2.default.createElement(
            'span',
            { className: 'display-block caption font-small font-black-variant ' },
            '\xA0'
          ),
          _react2.default.createElement(
            'span',
            { className: 'display-block font-medium font-black-variant ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "tag", "sub-header-2"), 'data-testid': this.props.dataTest + '-amount' },
            _react2.default.createElement(_formatted_number2.default, { value: amount, numberFormat: this.props.numberFormat })
          )
        ),
        !isLocalTimeZone && this.renderChangeAmount(changeAmount, changePerPercentage)
      );
    }
  }, {
    key: 'renderIntradayNavWithLocalTimezone',
    value: function renderIntradayNavWithLocalTimezone(asOfDate, intradayNavPrice) {
      var _this3 = this;

      var decimalPlaces = (0, _ramda.includes)("INTRADAY_NAV_ROUNDING_TWO", this.props.visibleDataPoints) ? 2 : 4;
      return _react2.default.createElement(
        'div',
        null,
        this.renderNavHeaderAndAsOfDate(asOfDate, intradayNavPrice, this.props.intraDayNav.length > 0 ? this.props.intraDayNav[0].timeZone : null),
        _react2.default.createElement(
          'div',
          { className: 'display-inline-block margin-top-5 margin-right-10' },
          _react2.default.createElement(
            'span',
            null,
            mapIndexed(function (data, i) {
              return _react2.default.createElement(
                'div',
                { className: 'caption header', key: i },
                _react2.default.createElement(
                  'span',
                  { 'data-testid': _this3.props.dataTest + '-intraday-time-' + (i + 1), className: 'caption header font-slate-grey font-small' },
                  _date_formatter2.default.getTimeInHoursAndMinutesInTimeZoneFormat(data.intraDayDateTime, "UTC", true)
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  ' '
                ),
                _react2.default.createElement(
                  'span',
                  { 'data-testid': _this3.props.dataTest + '-intraday-data-' + (i + 1), className: 'caption font-normal font-black-variant header' },
                  _react2.default.createElement(_formatted_number2.default, { value: _currency_utility2.default.convertToCurrencyForNav(parseFloat(data.price).toFixed(decimalPlaces), _this3.props.currencyCode, _this3.props.fundTypeCode, _this3.props.country, decimalPlaces), numberFormat: _this3.props.numberFormat })
                )
              );
            }, this.props.intraDayNav)
          )
        )
      );
    }
  }, {
    key: 'renderIntradayNavWithESTTimeZone',
    value: function renderIntradayNavWithESTTimeZone(asOfDate, intradayNavPrice, changeAmount) {
      var _this4 = this;

      var isMoneyMarketFund = this.props.assetClass === "Money Market";

      return _react2.default.createElement(
        'div',
        null,
        this.renderNavHeaderAndAsOfDate(asOfDate, intradayNavPrice),
        _react2.default.createElement(
          'div',
          { className: 'display-inline-block margin-top-5 margin-right-10' },
          _react2.default.createElement(
            'span',
            null,
            mapIndexed(function (data, i) {
              return _react2.default.createElement(
                'div',
                { className: 'caption header', key: i },
                _react2.default.createElement(
                  'span',
                  { 'data-testid': _this4.props.dataTest + '-intraday-time-' + (i + 1), className: 'caption header font-slate-grey font-small' },
                  _date_formatter2.default.getTimeInHoursAndMinutesInESTFormat(data.intraDayDateTime),
                  ':'
                ),
                ' ',
                _react2.default.createElement(
                  'span',
                  { 'data-testid': _this4.props.dataTest + '-intraday-data-' + (i + 1), className: 'caption font-normal font-black-variant header' },
                  _currency_utility2.default.convertToCurrencyWithoutDecimals(parseFloat(data.price).toFixed(4), _this4.props.currencyCode)
                )
              );
            }, this.props.intraDayNav)
          )
        ),
        !isMoneyMarketFund && this.renderChangeAmount(changeAmount)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var intradaynavdDisplay = this.props.intraDayNav && this.props.intraDayNav.length > 0;
      var changeAmount = this.props.nav.price ? this.props.nav.changeAmount : null;

      if (intradaynavdDisplay) {
        var intradayNavPrice = this.props.intraDayNav[0].price;
        var asOfDate = _date_formatter2.default.getLocalFormattedDate(this.props.intraDayNav[0].intraDayDateTime, this.props.country);

        if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'QUICK_STAT_NAV_WITH_LOCAL_TIMEZONE')) {
          return this.renderIntradayNavWithLocalTimezone(asOfDate, intradayNavPrice);
        }

        return this.renderIntradayNavWithESTTimeZone(asOfDate, intradayNavPrice, changeAmount);
      }

      var isLocalTimeZone = false;

      if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'QUICK_STAT_NAV_WITH_LOCAL_TIMEZONE')) {
        isLocalTimeZone = true;
      }

      return this.renderNav(isLocalTimeZone, changeAmount);
    }
  }]);

  return NAV;
}(_react2.default.Component);

exports.default = NAV;